import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core'
import { CtaCardModel } from '@flocasts/experience-service-types'

@Component({
  selector: 'flo-favorites-cta',
  templateUrl: './favorites-cta.component.html',
  styleUrls: ['./favorites-cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FavoritesCtaComponent {
  @Input() cta: CtaCardModel
}
